import { addChannel } from './addChannel';
import { cancelCollect } from './cancelCollect';
import { channelOperation } from './channelOperation';
import { channelType } from './channelType';
import cmsChannel from './cmsChannel';
import { collect } from './collect';
import { deleteChannel } from './deleteChannel';
import { getChannel } from './getChannel';
import { getChannelIntroduce } from './getChannelIntroduce';
import { list } from './list';
import { listAdmin } from './listAdmin';
import { listAllChannel } from './listAllChannel';
import { listAllChannelTree } from './listAllChannelTree';
import { listBusinessChannel } from './listBusinessChannel';
import { listChannel } from './listChannel';
import { listChildChannel } from './listChildChannel';
import listCmsChannel from './listCmsChannel';
import { listCollectChannel } from './listCollectChannel';
import { listHistory } from './listHistory';
import { listManageChannel } from './listManageChannel';
import { listPlatformChannel } from './listPlatformChannel';
import { listUpload } from './listUpload';
import { move } from './move';
import { saveChannelIntroduce } from './saveChannelIntroduce';
import { towerIdsValidate } from './towerIdsValidate';
import { updateChannel } from './updateChannel';
import { upload } from './upload';
import { uploadExcel } from './uploadExcel';
import { uploadPic } from './uploadPic';

export default {
  addChannel,
  cancelCollect,
  channelOperation,
  channelType,
  cmsChannel,
  collect,
  deleteChannel,
  getChannel,
  getChannelIntroduce,
  list,
  listAdmin,
  listAllChannel,
  listAllChannelTree,
  listBusinessChannel,
  listChannel,
  listChildChannel,
  listCmsChannel,
  listCollectChannel,
  listHistory,
  listManageChannel,
  listPlatformChannel,
  listUpload,
  move,
  saveChannelIntroduce,
  towerIdsValidate,
  updateChannel,
  upload,
  uploadExcel,
  uploadPic,
};
